import { render, staticRenderFns } from "./BtnAtualizarFaseContrato.vue?vue&type=template&id=0140ec67"
import script from "./BtnAtualizarFaseContrato.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarFaseContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports